export const dynamic = 'force-dynamic'
import { Metadata } from 'next';
// import BrandPage from "@/components/Brand/BrandPage";
import urls from '@/utils/urls/urls';
import cl from '@/utils/console/cl';
import Link from 'next/link';
import AnimationWrapper from '@/components/AnimationWrapper/AnimationWrapper';

export const metadata: Metadata = {
  title: 'Brand | TEX EXCELLENCE LIMITED',
  description: 'Brand | TEX EXCELLENCE LIMITED',
}

export default async function BrandPage() {
  const res = await fetch(urls?.brand, {
    cache: 'no-store'
  })
  if (!res.ok) {
    // throw new Error(`res status: ${res.status}`);
    return (<div>Error</div>)
  }
  const data = await res.json()
  const brands = data?.data || []
  // cl("brands", brands)

  return (
    <div className="bg-white">
      <main className="main">
        {/* breadcrumb */}
        <div
          className="site-breadcrumb"
          style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
        >
          <div className="container">
            <h2 className="breadcrumb-title">Brand</h2>
            <ul className="breadcrumb-menu">
              <li>
                <a href="index-2">Home</a>
              </li>
              <li className="active">Brand</li>
            </ul>
          </div>
        </div>
        {/* breadcrumb end */}
        {/* about area */}

        {/* choose area */}
        {
          brands?.map((brand: any, index: number) => (
            <div className="choose-area py-100" key={index}>
              <div className="container">
                <div className="row d-flex">
                  <div className="col-lg-6">
                  <AnimationWrapper animation="fade-left">
                    <div className="choose-content wow fadeInUp" data-wow-delay=".25s">
                      <div className="site-heading mb-0">
                        <span className="site-title-tagline">
                          <i className="fas fa-solar-panel" /> Brand
                        </span>
                        <h2 className="site-title">
                          {brand?.name}

                        </h2>
                        <p>
                          {brand?.description}
                        </p>
                        {
                          brand?.btn_text ? <Link href={brand?.btn_link} target="__blank" className="theme-btn2 mt-5">
                            Learn More
                            <i className="fas fa-arrow-right" />
                          </Link> : ""
                        }

                      </div>
                      {/* <div className="choose-content-wrap">
                  <div className="choose-item">
                    <div className="choose-item-icon">
                      <img src="assets/img/icon/money-2.svg" alt="" />
                    </div>
                    <div className="choose-item-info">
                      <h4>About</h4>
                      <p>
                      Vanguard Pailung has been manufacturing precision, quality and innovative custom designed knitting machines in the USA since 1916. Combined with a full line of knitting machines, Vanguard Pailung also provides OEM parts, expert technical service and fabric design consultation throughout North America, Mexico, Central America and South America. Fabric scope includes, but is not limited to, T-shirts, Fleece wear, sportswear, casual wear, industrial fabrics, medical fabrics and packaging fabrics.
                      </p>
                    </div>
                  </div>
                  <div className="choose-item">
                    <div className="choose-item-icon">
                      <img src="assets/img/icon/staff.svg" alt="" />
                    </div>
                    <div className="choose-item-info">
                      <h4>Our Experience Team</h4>
                      <p>
                        There are many variations of passages available the
                        majority have suffered alteration in some by injected
                        humour.
                      </p>
                    </div>
                  </div>
                  <div className="choose-item">
                    <div className="choose-item-icon">
                      <img src="assets/img/icon/certified.svg" alt="" />
                    </div>
                    <div className="choose-item-info">
                      <h4>Certified Company</h4>
                      <p>
                        There are many variations of passages available the
                        majority have suffered alteration in some by injected
                        humour.
                      </p>
                    </div>
                  </div>
                </div> */}
                    </div>
                    </AnimationWrapper>
                  </div>
                  <div className="col-lg-6">
                    <AnimationWrapper animation="fade-right">
                      <div className="choose-img wow fadeInRight" data-wow-delay=".25s">
                        <img className="shape shape-img" src={urls?.image + brand?.logo} alt="" />
                        <img className="img-1" src={urls?.image + brand?.image} alt="" />
                        <img className="img-2" src={urls?.image + brand?.image1} alt=""
                          style={{
                            width: "300px",
                          }} />
                      </div>
                    </AnimationWrapper>
                  </div>
                </div>
              </div>
            </div>
          ))
        }

        {/* choose area end */}
        {/* partner area */}
        {/* partner area end */}
      </main>
    </div>
  )
}
